
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { iHotGameDetails } from '@/interface/hot-game';
import { iHotTypeGame, iHotGameSearch } from '@/interface/hot-game';
import { getHotGame } from '@/api/android';
@Component({})
export default class HotEdit extends Vue {
  list: iHotGameDetails[] = [];
  @Prop() kind_id!: number;
  @Prop() endpoint!: number;
  searchInfo: iHotGameSearch = {
    title: '',
    game_name: '',
    page: 1,
    size: 20,
    endpoint: this.endpoint,
    kind_id: this.kind_id,
  };
  async getHotGame() {
    //  console.log(this.searchInfo);
    this.list = [];
    const res = await getHotGame(this.searchInfo);
    if (res && res.code == 0) {
      this.list = res.data.rows;
    }
  }
  @Watch('kind_id')
  onChangeValue(newVal: number, oldVal: number) {
    // console.log(newVal, oldVal);
    if (newVal != oldVal) {
      this.searchInfo.kind_id = newVal;
      this.getHotGame();
    }
  }
  mounted() {
    this.getHotGame();
  }
}
